module.exports = __webpack_public_path__ + "assets/img/img333.6ea1690b.png";